import React from "react";
import BarsContainer from "../bars";
import HomeDoble from "../doubleHome";
import Home from "../home";
import {
  getModuleAmp,
  getModuleOCWeb,
  getModuleWeb,
  MODULE_TYPES,
  LA_SEXTA,
  ANTENA3,
  ONDACERO
} from "../moduleGenerator/utils";
import Pactometro from "../pactometro";


import { useRESTDataCache } from '@atresmedia/elections_modules_library/dist/dataProvider';
import { TYPES } from '@atresmedia/elections_modules_library/dist/envs';
import Card from '@atresmedia/elections_modules_library/dist/components/card';

import SumaBloques from "../sumaBloques";
import { getParams } from "../../utils";
import RankingPactometro from "../rankingPactometro";
import { PROPERTIES_JSON } from "../../core/constants";

const getAMPHeight = (type, electionType, location) => {
  switch (type) {
    case MODULE_TYPES.HOME:
      return 900; //resultados;
    case MODULE_TYPES.HOME_DOBLE:
      return 1220; //resultadosDobles;
    case MODULE_TYPES.PACTOS:
      return 410; //pactometro;
    case MODULE_TYPES.BARRAS:
      return 360; //bars;
    case MODULE_TYPES.RANKING:
      return 760; //rankingPactometro;
    case MODULE_TYPES.MINI:
      return 260; //sumaBloques;
    default:
      throw new Error("Error");
  }
};

const getHtmlName = (type, electionType, location) => {
  switch (type) {
    case MODULE_TYPES.HOME:
    case MODULE_TYPES.HOME_DOBLE:
      switch (electionType) {
        case TYPES.GENERAL:
          return location && location.typePlace === "TOWN"
            ? "detalle"
            : "resultados";
        case TYPES.REGIONAL:
          return location.typePlace === "TOWN"
            ? "detalleAutonomica"
            : "resultados";
        case TYPES.MUNICIPAL:
          return location.typePlace === "TOWN"
            ? "detalleMunicipal"
            : "resultados";
        case TYPES.EUROPEAN:
          return location.typePlace === "TOWN"
            ? "detalleEuropeas"
            : "resultados";
        default:
          throw new Error("Error");
      }
    case MODULE_TYPES.PACTOS:
      return "pactometro";
    case MODULE_TYPES.ARCO:
      return "graficas";
    case MODULE_TYPES.BARRAS:
      return "bars";
    case MODULE_TYPES.RANKING:
      return "rankingPactometro";
    case MODULE_TYPES.MINI:
      return "sumaBloques";
    case MODULE_TYPES.ARCO_SENADO:
      return "senate";
    default:
      throw new Error("Error");
  }
};

const getLocationPath = (type, locations) => {
  let location = locations[0];
  let firstParams = getParams(location);
  const {
    communities = firstParams.community,
    provinces = firstParams.province,
    towns = firstParams.town
  } = getDoubleParams(locations.map(getParams));

  return `${communities}${provinces ? "/" + provinces : ""}${
    towns ? "/" + towns : ""
  }`;
};

const getChartType = (type, site) => {
  switch (type) {
    case MODULE_TYPES.HOME:
    case MODULE_TYPES.HOME_DOBLE:
      switch (site) {
        case LA_SEXTA:
          return "bars";
        case ONDACERO:
        case ANTENA3:
          return "arc";
        default:
          return "";
      }
    default:
      return "";
  }
};

const getUrlImg = site => {
  switch (site) {
    case LA_SEXTA:
      return "https://www.lasexta.com/public/img/grupo-atresmedia.svg";
    case ONDACERO:
      return "https://www.ondacero.es/public/img/grupo-atresmedia.svg";
    case ANTENA3:
      return "https://www.antena3.com/public/img/grupo-atresmedia.svg";
    default:
      return "";
  }
};

const getUrl = (
  type,
  electionType,
  locations,
  navegable,
  chartTypes,
  community,
  site,
  year
) => {
  if (electionType !== TYPES.GENERAL) {
    return `/1/${navegable}/${year}/REGIONAL/1/${
      chartTypes ? chartTypes + "/" : ""
    }${getLocationPath(electionType, locations)}/${getHtmlName(
      type,
      electionType,
      locations
    )}.html`;
  } else if (locations.length > 0) {
    return `/C108/${navegable}/${year}/GENERAL/1/${
      chartTypes ? chartTypes + "/" : ""
    }${getLocationPath(electionType, locations)}/${getHtmlName(
      type,
      electionType,
      locations
    )}.html`;
  } else {
    return `/C108/${navegable}/${year}/GENERAL/1/${
      chartTypes ? chartTypes + "/" : ""
    }${getHtmlName(type, electionType, locations)}.html`;
  }
};

const getDoubleParams = communities => {
  console.log(communities);
  return communities.reduce(
    (total, current, i, arr) => {
      let separator = "-";
      if (i === arr.length - 1) {
        separator = "";
      }
      if (current.community) {
        total.communities = total.communities + current.community + separator;
      }
      if (current.province) {
        total.provinces = total.provinces + current.province + separator;
      }
      if (current.town) {
        total.towns = total.towns + current.town + separator;
      }
      return total;
    },
    { communities: "", provinces: "", towns: "" }
  );
};

const Module = data => {
  const params = useRESTDataCache(PROPERTIES_JSON(), "GLOBAL_CONFIG", null);
  const { type, electionType, locations = [], navegable, site, year } = data;
  const location = locations[0];
  const moduleId = "elections_module_" + new Date().getTime();

  const { community, province = "", town = "" } = getParams(location);
  const chartType = getChartType(type, site);

  const url = getUrl(
    type,
    electionType,
    locations,
    navegable,
    chartType,
    community,
    site,
    year
  );
  const urlImg = getUrlImg(site);
  const moduleHeight = getAMPHeight(type, electionType, locations);
  const moduleWeb =
    site === ONDACERO
      ? getModuleOCWeb(moduleId, url, moduleHeight)
      : getModuleWeb(moduleId, url);
  const moduleAmp = getModuleAmp(url, moduleHeight, urlImg);

  const typeElec = TYPES.REGIONAL;

  const match = {
    params: {
      year,
      type: typeElec,
      electionType: typeElec,
      electionNumber: "1",
      placeId: typeElec === TYPES.REGIONAL ? community : "C108",
      province,
      community,
      town,
      site: site,
      //Para doble home
      provinces: province,
      communities: community,
      towns: town,
      chartType,
      chartTypes: chartType,
      placesIds: typeElec === TYPES.REGIONAL ? community : "C108"
    }
  };

  if (locations.length > 1) {
    match.params = {
      ...match.params,
      ...getDoubleParams(locations.map(getParams))
    };
  }

  if (!params) {
    return <div>loading...</div>;
  }
  return (
    <div>
      <Card title="Vista previa" className="vistaprevia" isCollapsed="true">
        {type === MODULE_TYPES.BARRAS && <BarsContainer match={match} />}
        {type === MODULE_TYPES.HOME && <Home match={match} />}
        {type === MODULE_TYPES.HOME_DOBLE && <HomeDoble match={match} />}
        {type === MODULE_TYPES.PACTOS && <Pactometro match={match} />}
        {type === MODULE_TYPES.MINI && <SumaBloques match={match} />}
        {type === MODULE_TYPES.RANKING && <RankingPactometro match={match} />}
      </Card>

      <Card title="Módulos" className="vistaprevia">
        <div className="two">
          <h3>Módulo web</h3>
          <textarea readOnly value={moduleWeb} />
        </div>
        <div className="two">
          <h3>Módulo AMP</h3>
          <textarea readOnly value={moduleAmp} />
        </div>
      </Card>
    </div>
  );
};

export default Module;
